__turbopack_context__.v({
  "hero": "Hero-module-scss-module__MzUR1G__hero",
  "img-wrapper": "Hero-module-scss-module__MzUR1G__img-wrapper",
  "title": "Hero-module-scss-module__MzUR1G__title",
  "title-wrapper": "Hero-module-scss-module__MzUR1G__title-wrapper",
});
